import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-cards';
import yutaImage1 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -25.jpg';
import yutaImage2 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -26.jpg';
import yutaImage3 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -27.jpg';
import yutaImage4 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -38.jpg';
import yutaImage5 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -43.jpg';

const FeaturedModel = () => {
  // Custom styles for Swiper to match theme
  const swiperStyles = `
    .featured-pagination {
      display: flex;
      justify-content: center;
      margin-top: 1rem; /* 16px */
    }
    .featured-pagination .swiper-pagination-bullet {
      background: rgba(255, 159, 102, 0.4) !important;
      width: 12px !important;
      height: 12px !important;
      margin: 0 6px !important;
      border-radius: 50% !important;
      transition: all 0.3s ease !important;
      opacity: 1 !important;
      cursor: pointer !important;
    }
    .featured-pagination .swiper-pagination-bullet-active {
      background: #FF7A33 !important;
      transform: scale(1.1) !important;
      box-shadow: 0 0 8px rgba(255, 122, 51, 0.5) !important;
    }
    .featured-swiper .swiper-slide {
      border-radius: 8px !important;
      overflow: hidden !important;
    }
  `;

  // Images for Swiper - actual Yuta C6 Peritus photos
  const featuredImages = [
    {
      src: yutaImage1,
      alt: "Yuta C6 Peritus - Front View"
    },
    {
      src: yutaImage2,
      alt: "Yuta C6 Peritus - Detail View"
    },
    {
      src: yutaImage3,
      alt: "Yuta C6 Peritus - Side View"
    },
    {
      src: yutaImage4,
      alt: "Yuta C6 Peritus - Back View"
    },
    {
      src: yutaImage5,
      alt: "Yuta C6 Peritus - Headstock Detail"
    },
  ];

  return (
    <section id="featured" className="py-20 bg-theme-bg-primary">
      <style dangerouslySetInnerHTML={{ __html: swiperStyles }} />
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold">Featured Build - Yuta C6 Peritus</h2>
        </div>
        {/* Single Container for Image and Details */}
        <div className="bg-theme-bg-secondary/50 backdrop-blur-sm rounded-lg shadow-2xl p-8 text-theme-text-secondary border border-theme-text-primary/10 max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-8">
            {/* Swiper Carousel */}
            <div className="w-full lg:w-1/2 flex justify-center lg:justify-start">
              <div className="w-full max-w-[360px] flex flex-col items-center lg:items-start">
                <Swiper
                  modules={[Pagination, Autoplay]}
                  slidesPerView={1}
                  spaceBetween={30}
                  grabCursor={true}
                  pagination={{
                    el: '.featured-pagination',
                    clickable: true,
                    enabled: true,
                  }}
                  autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                  }}
                  className="featured-swiper rounded-lg shadow-2xl w-full h-[560px]"
                >
                {featuredImages.map((image, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                    />
                  </SwiperSlide>
                ))}
                </Swiper>
                <div className="featured-pagination w-full"></div>
              </div>
            </div>

            {/* Model Specifications */}
            <div className="w-full lg:w-1/2">

              <div className="grid grid-cols-1 gap-y-6 mb-8">
                {/* Guitar Specs */}
                <div>
                  <h4 className="text-xl font-semibold mb-3 text-theme-text-primary border-b border-theme-primary-500/30 pb-2 flex items-center gap-2"><i className="fas fa-guitar text-theme-primary-500"></i> Guitar Specs</h4>
                  <ul className="space-y-1 text-sm">
                    <li><strong>Scale:</strong> Standard 25.5"</li>
                    <li><strong>Body:</strong> Swamp Ash</li>
                    <li><strong>Top:</strong> Wenge</li>
                    <li><strong>Neck:</strong> Set-neck 5-piece construction – Maple, Wenge, and White Wenge with gray veneer layers</li>
                    <li><strong>Fretboard:</strong> Ebony with double binding – Flamed Maple and gray veneer</li>
                    <li><strong>Frets:</strong> 22 Jescar stainless steel frets</li>
                    <li><strong>Inlay:</strong> VitaeGuitars Tree – White Wenge with three shades of glow-in-the-dark green</li>
                    <li><strong>Pickup Ring:</strong> Flamed Maple</li>
                    <li><strong>Finish:</strong> Borma Wachs Parquet Oil 2K</li>
                  </ul>
                </div>

                {/* Hardware */}
                <div>
                  <h4 className="text-xl font-semibold mb-3 text-theme-text-primary border-b border-theme-primary-500/30 pb-2 flex items-center gap-2"><i className="fas fa-tools text-theme-primary-500"></i> Hardware</h4>
                  <ul className="space-y-1 text-sm">
                    <li><strong>Tuners:</strong> Graphtech Ratio staggered chrome set</li>
                    <li><strong>Nut:</strong> Special artificial bone cement</li>
                    <li><strong>Bridge:</strong> Mastery M4 Tele Bridge</li>
                    <li><strong>Knobs:</strong> Hipshot O-Ring chrome</li>
                    <li><strong>String Ferrules:</strong> Hosco chrome</li>
                    <li><strong>Truss Rod:</strong> Double action with spoke wheel adjustment</li>
                  </ul>
                </div>

                {/* Electronics */}
                <div>
                  <h4 className="text-xl font-semibold mb-3 text-theme-text-primary border-b border-theme-primary-500/30 pb-2 flex items-center gap-2"><i className="fas fa-bolt text-theme-primary-500"></i> Electronics</h4>
                  <ul className="space-y-1 text-sm">
                    <li><strong>Pickups:</strong> TV Jones - Starwood Tele Set</li>
                    <li><strong>Potentiometers:</strong> Burns</li>
                    <li><strong>Capacitors:</strong> Russian NOS</li>
                  </ul>
                </div>
              </div>

              {/* Price and CTA */}
              <div className="pt-6 border-t border-theme-primary-500/30 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <p className="text-3xl font-bold text-theme-text-primary text-center sm:text-left">$5,800</p>
                <button
                  onClick={() => window.location.href = '/builder'}
                  className="bg-theme-primary-500 text-white px-6 py-3 font-semibold rounded-button shadow-lg hover:bg-theme-primary-600 transition-all transform hover:-translate-y-1 cursor-pointer"
                >
                  Customize Yours
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedModel;
